import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";

const AllowedAppsSelector = ({ onChange, defaultValue }) => {
  const options = [
    { id: "trivision", title: "TV Trivision" },
    { id: "livecast", title: "Live Cast" },
  ];
  const selectedApps = options.filter(opt =>
    defaultValue.includes(opt.id)
  );
  return (
    <Autocomplete
      id="combo-box-demo"
      options={options}
      getOptionLabel={(option) => option.title}
      value={selectedApps}
      style={{ width: 300 }}
      isOptionEqualToValue={(option, value) =>
        option.id === value.id
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Allowed Apps"
          variant="outlined"
          size="small"
        />
      )}
      onChange={onChange}
      multiple
    />
  );
};

export default AllowedAppsSelector;
